"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hpOnboadingWatchers = hpOnboadingWatchers;
var _effects = require("redux-saga/effects");
var _sagas = require("../../auth/login/redux/sagas");
var api = _interopRequireWildcard(require("../api/api"));
var actions = _interopRequireWildcard(require("./actions"));
var _utils = require("../../../common/utils/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function* getHPOnboardingData(params) {
  try {
    const {
      onSuccess,
      param,
      showLoader = true
    } = params.data;
    if (_utils.isMobile && showLoader || !_utils.isMobile) {
      yield (0, _effects.put)(actions.GET_HP_ONBOARDING_DATA_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getHPOnboardingData, tokenData, param);
    yield (0, _effects.put)(actions.GET_HP_ONBOARDING_DATA_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_HP_ONBOARDING_DATA_API.failure(err));
    params.data.onFailure(err);
  }
}
function* postHPEntry(params) {
  try {
    const {
      onSuccess,
      requestParams,
      showLoader = true
    } = params.data;
    if (_utils.isMobile && showLoader || !_utils.isMobile) {
      yield (0, _effects.put)(actions.POST_HP_ENTRY_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.postHPEntry, requestParams, tokenData);
    yield (0, _effects.put)(actions.POST_HP_ENTRY_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.POST_HP_ENTRY_API.failure(err));
    params.data.onFailure(err);
  }
}
function* postHPCustomizeConfig(params) {
  try {
    const {
      onSuccess,
      requestParams,
      showLoader = true
    } = params.data;
    if (_utils.isMobile && showLoader || !_utils.isMobile) {
      yield (0, _effects.put)(actions.POST_HP_VIEW_CONFIG.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.postHPCustomizeConfig, requestParams, tokenData);
    yield (0, _effects.put)(actions.POST_HP_VIEW_CONFIG_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.POST_HP_VIEW_CONFIG_API.failure(err));
    params.data.onFailure(err);
  }
}
function* deleteHPEntry(params) {
  try {
    const {
      onSuccess,
      requestParams,
      showLoader = true
    } = params.data;
    if (_utils.isMobile && showLoader || !_utils.isMobile) {
      yield (0, _effects.put)(actions.DELETE_HP_ENTRY_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.deleteHPEntry, requestParams, tokenData);
    yield (0, _effects.put)(actions.DELETE_HP_ENTRY_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.DELETE_HP_ENTRY_API.failure(err));
    params.data.onFailure(err);
  }
}
function* getPatientWiseHPOnboardingData(params) {
  try {
    const {
      onSuccess,
      param,
      showLoader = true
    } = params.data;
    if (_utils.isMobile && showLoader || !_utils.isMobile) {
      yield (0, _effects.put)(actions.GET_PATIENT_HP_ONBOADING_DATA_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getPatientHPOnboardingData, param, tokenData);
    yield (0, _effects.put)(actions.GET_PATIENT_HP_ONBOADING_DATA_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PATIENT_HP_ONBOADING_DATA_API.failure(err));
    params.data.onFailure(err);
  }
}
function* getFirstTimeAccess(params) {
  try {
    yield (0, _effects.put)(actions.GET_FIRST_TIME_ACCESS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getFirstTimeAccessApi, params.data.param, tokenData);
    yield (0, _effects.put)(actions.GET_FIRST_TIME_ACCESS_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_FIRST_TIME_ACCESS_API.failure(err));
    params.data.onFailure(err);
  }
}
function* getHPViewAllData(params) {
  try {
    const {
      onSuccess,
      param,
      showLoader = true
    } = params.data;
    if (_utils.isMobile && showLoader || !_utils.isMobile) {
      yield (0, _effects.put)(actions.GET_HP_VIEW_ALL_DATA_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getHPViewAllData, param, tokenData);
    yield (0, _effects.put)(actions.GET_HP_VIEW_ALL_DATA_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_HP_VIEW_ALL_DATA_API.failure(err));
    params.data.onFailure(err);
  }
}
function* getHPCustomizeConfig(params) {
  try {
    const {
      onSuccess,
      param,
      showLoader = true
    } = params.data;
    if (_utils.isMobile && showLoader || !_utils.isMobile) {
      yield (0, _effects.put)(actions.GET_HP_VIEW_ALL_DATA_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getHPCustomizeConfig, param, tokenData);
    yield (0, _effects.put)(actions.GET_HP_VIEW_CONFIG_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_HP_VIEW_CONFIG_API.failure(err));
    params.data.onFailure(err);
  }
}
function* getOnboardingSync(params) {
  try {
    yield (0, _effects.put)(actions.GET_ONBOARDING_SYNC_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getOnboardingSync, params.data.requestParams, tokenData);
    yield (0, _effects.put)(actions.GET_ONBOARDING_SYNC_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_ONBOARDING_SYNC_API.failure(err));
    params.data.onFailure(err);
  }
}
function* getHealthFeed(params) {
  const {
    showLoader = true
  } = params === null || params === void 0 ? void 0 : params.data;
  try {
    var _params$data, _params$data2;
    if (showLoader) {
      yield (0, _effects.put)(actions.GET_HP_HEALTH_FEED_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getHealthFeed, params === null || params === void 0 || (_params$data = params.data) === null || _params$data === void 0 ? void 0 : _params$data.requestParams, tokenData);
    yield (0, _effects.put)(actions.GET_HP_HEALTH_FEED_API.success(mainResponse));
    params === null || params === void 0 || (_params$data2 = params.data) === null || _params$data2 === void 0 || _params$data2.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_HP_HEALTH_FEED_API.failure(err));
    params.data.onFailure(err);
  }
}
function* resetHistoricalSync(params) {
  try {
    const {
      onSuccess,
      requestParams,
      showLoader = true
    } = params.data;
    if (_utils.isMobile && showLoader || !_utils.isMobile) {
      yield (0, _effects.put)(actions.RESET_HISTORICAL_SYNC_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.resetHistoricalSync, requestParams, tokenData);
    yield (0, _effects.put)(actions.RESET_HISTORICAL_SYNC_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.RESET_HISTORICAL_SYNC_API.failure(err));
    params.data.onFailure(err);
  }
}
function* getHistoricalSyncTimestamp(params) {
  try {
    const {
      onSuccess,
      requestParams,
      showLoader = true
    } = params.data;
    if (_utils.isMobile && showLoader || !_utils.isMobile) {
      yield (0, _effects.put)(actions.GET_HISTORICAL_SYNC_TIMESTAMP_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getHistoricalSyncTimestamp, requestParams, tokenData);
    yield (0, _effects.put)(actions.GET_HISTORICAL_SYNC_TIMESTAMP_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_HISTORICAL_SYNC_TIMESTAMP_API.failure(err));
    params.data.onFailure(err);
  }
}
function* getHpSummary(params) {
  const {
    showLoader = true
  } = params.data;
  try {
    if (showLoader) {
      yield (0, _effects.put)(actions.GET_HP_SUMMARY_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getHpSummary, params.data.requestParams, tokenData);
    yield (0, _effects.put)(actions.GET_HP_SUMMARY_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_HP_SUMMARY_API.failure(err));
    params.data.onFailure(err);
  }
}
function* hpOnboadingWatchers() {
  yield (0, _effects.takeEvery)(actions.GET_HP_ONBOARDING_DATA, getHPOnboardingData);
  yield (0, _effects.takeEvery)(actions.GET_HP_HEALTH_FEED, getHealthFeed);
  yield (0, _effects.takeLatest)(actions.POST_HP_ENTRY, postHPEntry);
  yield (0, _effects.takeEvery)(actions.GET_PATIENT_HP_ONBOADING_DATA, getPatientWiseHPOnboardingData);
  yield (0, _effects.takeLatest)(actions.GET_FIRST_TIME_ACCESS, getFirstTimeAccess);
  yield (0, _effects.takeEvery)(actions.DELETE_HP_ENTRY, deleteHPEntry);
  yield (0, _effects.takeEvery)(actions.GET_HP_VIEW_ALL_DATA, getHPViewAllData);
  yield (0, _effects.takeLatest)(actions.GET_ONBOARDING_SYNC, getOnboardingSync);
  yield (0, _effects.takeLatest)(actions.GET_HP_SUMMARY, getHpSummary);
  yield (0, _effects.takeLatest)(actions.GET_HP_VIEW_CONFIG, getHPCustomizeConfig);
  yield (0, _effects.takeLatest)(actions.RESET_HISTORICAL_SYNC, resetHistoricalSync);
  yield (0, _effects.takeLatest)(actions.GET_HISTORICAL_SYNC_TIMESTAMP, getHistoricalSyncTimestamp);
  yield (0, _effects.takeLatest)(actions.POST_HP_VIEW_CONFIG, postHPCustomizeConfig);
}